import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Label,
  Input,
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { replaceEncaissement } from '../../flux/actions/encaissementActions';
import { IEncaissementReplacementConfirmComponent, IAuthReduxProps, ITarget } from '../../types/interfaces';

import { useAlert } from "react-alert";
import { E_ERROR } from '../../types/errors';
import { constants } from '../../types/constants';
import { getEncModeRegl } from '../../services/misc';

import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCheckCircle, faClipboardCheck, faExclamationTriangle, faFileImage, faFilePdf, faHandRock, faSpinner, faTimes, faTimesCircle} from '@fortawesome/free-solid-svg-icons'
import { instantPrint } from '../pdf/PDFLink';
import { useDropzone } from 'react-dropzone';
import { PRIVILEGE } from '../../types/privileges';
import moment from "moment";

const ConfirmEncaissement = ({ 
  replaceEncaissement,
  repList,
  projectGroup,
  refresh,
  setClearFilters,
  auth,
  }: IEncaissementReplacementConfirmComponent) => {
  const alert = useAlert();
  const [modal, setModal] = useState(false);
  const [commentValue, setCommentValue] = useState('');
  const [noDoc, setNoDoc] = useState(true);
  const [documents, setDocuments] = useState<any[]>([]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: ['application/pdf', 'image/*'],
    multiple: false,
    maxSize: 30000000,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setDocuments(acceptedFiles);
      if(rejectedFiles?.length && rejectedFiles[0].errors){
        if(rejectedFiles[0].errors.find(e => e.code === "file-invalid-type"))
          alert.error("Veuillez sélectionner des fichiers du type PDF ou Image")
        else if(rejectedFiles[0].errors.find(e => e.code === "file-too-large"))
          alert.error("La taille du fichier est supérieure à 30 Mo")
      }
    }
  });
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [reEnable, setReEnable] = useState(false);
  
  const handleToggle = () => setModal(!modal);

  const modalClosedHandle = () => {
    if(reEnable){
      setDisableSubmit(false);
      setReEnable(false);
    }
  };
  const commentChangeHandler = (e: ITarget) => setCommentValue(e.target.value);
  const noDocChangeHandle = e => setNoDoc(e.target.checked)

  const callback = (success, print = false) => {
    if(success?.success){
      setReEnable(true);
      setModal(false);
      if(alert.removeAll && typeof alert.removeAll === "function")
        alert.removeAll()
      alert.success("Encaissements modifiés"/*, {timeout: 0}*/);
      if(print){
        // instantPrint({
        //   documentType: "encaissements",
        //   data: {encaissements: success.encaissements, encTitle: "Encaissements À Verser", projectName: success.projectName, bv: success.bv},
        //   showPreviewWatermark: false,
        // });
      }
      refresh();
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmit(false);
  }

  const replaceEncaissementHandle = (action) => {
    if(!action){
      alert.error(E_ERROR.NO_ACTION);
      return
    }
    // if(action === constants.VALIDATE_CHECK)
    //   setClearFilters(true)
    if(repList.filter(e => !!e.replaced).length === 0){
      alert.error("Veuillez sélectionner les encaissement(s) remplacé(s)");
      return
    }
    // if(repList.filter(e => !!e.replacer).length === 0){
    //   alert.error("Veuillez sélectionner les encaissement(s) à attacher");
    //   return
    // }
    if(repList.filter(e => !!e.replaced).length && repList.filter(e => !!e.replacer).length){
      const replacedList = repList.filter(e => !!e.replaced)
      const replacerList = repList.filter(e => !!e.replacer)
      let found: any = null
      for(let i in replacedList){
        if(replacedList[i].MODE_REGL !== constants.MODE_REGL_CHEQUE)
          continue
        for(let j in replacerList){
          if(replacerList[j].MODE_REGL !== constants.MODE_REGL_CHEQUE)
            continue
          let replacedDateToTake, saisieIsAfter = false
          if(moment(replacedList[i].createdAt).isAfter(moment(replacedList[i].DATE_REGLEMENT))){
            replacedDateToTake = moment(replacedList[i].createdAt)
            saisieIsAfter = true
          }
          else{
            replacedDateToTake = moment(replacedList[i].DATE_REGLEMENT)
            saisieIsAfter = false
          }
          if(replacedDateToTake.isBefore(moment(replacerList[j].createdAt).subtract(1, 'months'))){
            found = {replacedDateToTake, saisieIsAfter, replaced: replacedList[i], replacer: replacerList[j]}
            break
          }
        }
      }
      if(found){
        let isGood = false
        if(replacerList.reduce((e, t) => e + Number(t.MONTANT || 0), 0) >= replacedList.reduce((e, t) => e + Number(t.MONTANT || 0), 0) && replacerList.every(e => e.MODE_REGL !== constants.MODE_REGL_CHEQUE || moment(e.DATE_REGLEMENT).isSameOrBefore(moment().add(1, 'month'))))
          isGood = true
        if(!isGood){
          alert.error(`La date saisie du remplaçant (${found.replacer?.REF_REGLEMENT} - ${moment(found.replacer?.createdAt).format('DD/MM/YYYY')}) dépasse 1 mois la date de${found.saisieIsAfter ? " saisie de" : ""} l'encaissement remplacé (${found.replaced?.REF_REGLEMENT} - ${found.replacedDateToTake?.format('DD/MM/YYYY')})`);
          if(!auth?.user?.privileges?.includes(PRIVILEGE.WEBMASTER))
            return
        }
      }
    }
    if(action === constants.VALIDATE_CHECK){
      setModal(true);
      return
    }
    else if(action === constants.VALIDATE_CONFIRM || action === constants.VALIDATE_CONFIRM_AND_PRINT){
      if(!noDoc && !documents?.length){
        alert.error("Veuillez sélectionner un document");
        return
      }
      setDisableSubmit(true);

      const uploadCallback = (upload: any = undefined) => {
        replaceEncaissement(repList?.filter(e => !!e.replacer).map(e => e.id || 0) || [], repList?.filter(e => !!e.replaced).map(e => e.id || 0) || [], commentValue, auth?.user && auth?.user.id ? auth?.user.id : undefined, auth?.user && auth?.user.username ? auth?.user.username : "", upload, callback, action === constants.VALIDATE_CONFIRM_AND_PRINT);
      }

      if(documents?.length){
        var reader = new FileReader();
        reader.onload = function() {
          var arrayBuffer = this.result,
            codedBuffer: string = "";
          (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
              codedBuffer += String.fromCharCode(byte);
          });
          uploadCallback({codedBuffer, isPdf: documents[0].type === "application/pdf" ? 1 : 0});
        }
        reader.readAsArrayBuffer(documents[0]);
      }
      else
        uploadCallback()
      return
    }
  }
  
  return (
    <>
      <Container className="confirmDiv" fixed="down">
        <Row className="justify-content-center">
          <Col xs="12" sm="6">
            <FormGroup>
              {/* <Label className="confirmDALabel">&nbsp;</Label> */}
              <Button
                className="btn btn-success confirmBtn"
                onClick={() => replaceEncaissementHandle(constants.VALIDATE_CHECK)}
                disabled={repList.length === 0}
                ><FontAwesomeIcon icon={faClipboardCheck} />&nbsp;&nbsp;{repList.filter(e => !!e.replaced).length ? `Récupérer ${repList.filter(e => !!e.replaced).length === 1 ? "l'" : `les ${repList.filter(e => !!e.replaced).length} `}encaissement${repList.filter(e => !!e.replaced).length === 1 ? "" : "s"}\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0${repList.filter(e => !!e.replaced).reduce((e, t) => {return t.MONTANT ? e + t.MONTANT : e}, 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH` : `Récupérer`}</Button>
            </FormGroup>
          </Col>
        </Row>
      </Container>

      <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faExclamationTriangle} />&nbsp;&nbsp;Remplacer les encaissements</ModalHeader>
        <ModalBody>
          <Container className="linesConfirmationContainer">
            <Row className="mb-2">
              <Col xs="12">
                Êtes-vous sûr de vouloir enlever <b>{repList.filter(e => !!e.replaced).length === 1 ? "l'" : `les ${repList.filter(e => !!e.replaced).length} `}encaissement{repList.filter(e => !!e.replaced).length === 1 ? "" : "s"}</b> ?
              </Col>
            </Row>
            {repList.filter(e => !!e.replaced).length ? <Row style={{justifyContent: "center", fontWeight: 700}}>
              <div style={{color: "orangered"}}>À Récupérer</div>&nbsp;({repList.filter(e => !!e.replaced).reduce((e, t) => e + Number(t.MONTANT || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)
            </Row> : null}
            {repList.filter(e => !!e.replaced).map((e, key) => (
              <Row className="linesConfirmationLines" key={key}>
                <Col xs="12">{getEncModeRegl(e.MODE_REGL)} N°: <b>{e.REF_REGLEMENT || "-"}</b> Montant: <b>{(e.MONTANT || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</b></Col>
              </Row>
            ))}
            {repList.filter(e => !!e.replacer).length ? <Row style={{justifyContent: "center", fontWeight: 700}}>
              <div style={{color: "green"}}>À Attacher</div>&nbsp;({repList.filter(e => !!e.replacer).reduce((e, t) => e + Number(t.MONTANT || 0), 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH)
            </Row> : null}
            {repList.filter(e => !!e.replacer).map((e, key) => (
              <Row className="linesConfirmationLines" key={key}>
                <Col xs="12">{getEncModeRegl(e.MODE_REGL)} N°: <b>{e.REF_REGLEMENT || "-"}</b> Montant: <b>{(e.MONTANT || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH</b></Col>
              </Row>
            ))}
            <Row>
              <Col xs="12">
                <div style={{position: "relative"}}>
                  <section>
                    <div {...getRootProps({className: `dropzone${isDragActive ? " dropzoneHovered" : ""}`})}>
                      <input {...getInputProps()} />
                      {documents?.length ? <aside className="thumbContainer">
                        <div className="thumbDelete" onClick={e => (e.stopPropagation(), setDocuments([]))} title="Supprimer le document"><FontAwesomeIcon icon={faTimes} style={{fontSize: "small"}} /></div>
                        <div className="thumb" style={{height: "auto"}} key={documents[0].name}>
                          <div className="thumbInner">
                            <span className="thumbFileName"><FontAwesomeIcon icon={faFilePdf} />&nbsp;{documents[0].name}</span>
                          </div>
                        </div>
                      </aside> : <span style={{margin: "20px"}}><FontAwesomeIcon icon={faFileImage} /> <FontAwesomeIcon icon={faFilePdf} /> Choisir ou <FontAwesomeIcon icon={faHandRock} /> déposer le <span style={{fontWeight: 600}}>{"document"}</span> ici</span>}
                    </div>
                  </section>
                  <div style={{display: "flex", justifyContent: "space-between", fontStyle: "italic", fontSize: "x-small", margin: "2px 0"}}>
                    {!documents?.length ? <div style={{display: "flex"}}>
                      <input type="checkbox" id="noDoc" checked={noDoc} onChange={noDocChangeHandle} style={{marginRight: "3px"}} />
                      <Label for="noDoc" check>Je ne dispose pas de document</Label>
                    </div> : <div></div>}
                    <a href="https://pdfjoiner.com/fr" target="_blank">Convertir des images en PDF</a>
                  </div>
                  {/* <div className="bottomFloatingInputText text-right"><a href="https://pdfjoiner.com/fr" target="_blank">Convertir des images en PDF</a></div> */}
                </div>
              </Col>
            </Row>
            <Row>
              <Col xs="12">
                <Input id="comment" type="textarea" placeholder="Commentaire..." value={commentValue} onChange={commentChangeHandler} />
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col xs="11" md="3">
                <Button
                  className="btn btn-info linesConfirmationBtn"
                  onClick={() => replaceEncaissementHandle(constants.VALIDATE_CONFIRM)}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Valider</Button>
              </Col>
              {/* <Col xs="11" md="7">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={() => replaceEncaissementHandle(constants.VALIDATE_CONFIRM_AND_PRINT)}
                  disabled={disableSubmit}
                  ><FontAwesomeIcon icon={disableSubmit ? faSpinner : faCheckCircle} className={disableSubmit ? "spinner" : ""} />&nbsp;&nbsp;Valider et Imprimer</Button>
              </Col> */}
            </Row>
          </Container>
        </ModalBody>
      </Modal>
      </>
  );
};

const mapStateToProps = (state: IAuthReduxProps) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { replaceEncaissement })(ConfirmEncaissement);
